import { Route, Routes } from "react-router-dom";
import { createContext } from "react";
import MessageBoxList from "../../modules/messageBox/components/MessageBoxList";

const MessageBoxContext = createContext();

const MessageBoxWrapper = () => {
  const value = {};

  return (
    <MessageBoxContext.Provider value={value}>
      <Routes>
        <Route path="" element={<MessageBoxList />} />
      </Routes>
    </MessageBoxContext.Provider>
  );
};

export { MessageBoxWrapper };
